import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  get_branch_attendance_report,
  get_branch_employee_attendance_report,
} from "../../../services/employeeApi";
import { formatDate } from "../../../utils/date_utils";
import { Form, Button, Nav, Tab } from "react-bootstrap";
import { useQueries } from "@tanstack/react-query";
import BasicTable from "../../../components/UiComponent/customTable";
import { GetUserInfo, hasAccess } from "../../../utils/permissionChecker";
import exportToExcel from "../../../utils/exportToExcel";
const AttendanceReport = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const today = new Date();
  const formatYYYYMMDD = (date) => date.toISOString().split("T")[0];
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  const [fromDate, setfromDate] = useState(formatYYYYMMDD(sevenDaysAgo));
  const [toDate, settoDate] = useState(formatYYYYMMDD(today));

  const branch_id = user?.employee?.branch_id;

  const [branchAttendanceQuery, employeeAttendanceQuery] = useQueries({
    queries: [
      {
        queryKey: ["branch_attendance_report", branch_id, fromDate, toDate],
        queryFn: () =>
          get_branch_attendance_report(branch_id, fromDate, toDate),
        enabled: !!branch_id,
        keepPreviousData: true,
      },
      {
        queryKey: [
          "branch_employee_attendance_report",
          branch_id,
          fromDate,
          toDate,
        ],
        queryFn: () =>
          get_branch_employee_attendance_report(branch_id, fromDate, toDate),
        enabled: !!branch_id,
        keepPreviousData: true,
      },
    ],
  });

  if (!branch_id) {
    return <div>No branch assigned to your profile. Contact admin.</div>;
  }

  if (branchAttendanceQuery.isError || employeeAttendanceQuery.isError) {
    return <div>Failed to load attendance data.</div>;
  }
  const branchAttendance = branchAttendanceQuery.data || [];
  const employeeAttendance = employeeAttendanceQuery.data || [];
  const attendanceColumns = [
    {
      header: "date",
      accessorFn: (row) => `${formatDate(row.date)}`,
    },
    {
      header: "total",
      accessor: "total",
      accessorFn: (row) => `${row.total}`,
    },
    {
      header: "Present",
      accessor: "present",
      accessorFn: (row) => `${row.present}`,
    },
    {
      header: "Late",
      accessor: "late",
      accessorFn: (row) => `${row.late}`,
    },
    {
      header: "Absent",
      accessor: "absent",
      accessorFn: (row) => `${row.absent}`,
    },
  ];
  const employeeAttendanceColumns = [
    {
      header: "employee",
      accessor: "employee",
      accessorFn: (row) => `${row.employee}`,
    },
    {
      header: "Present",
      accessor: "present",
      accessorFn: (row) => `${row.present}`,
    },
    {
      header: "Late",
      accessor: "late",
      accessorFn: (row) => `${row.late}`,
    },
    {
      header: "Absent",
      accessor: "absent",
      accessorFn: (row) => `${row.absent}`,
    },
  ];
  const employeeAttendanceExportColumns = [
    {
      header: "Employee Name",
      key: (row) => `${row.employee}`,
    },
    { header: "Days Present", key: (row) => row.present },
    { header: "Days Late", key: (row) => row.late },
    { header: "Days Absent", key: (row) => row.absent },
  ];

  const handleExport = () => {
    exportToExcel({
      data: employeeAttendance?.summary,
      columnsConfig: employeeAttendanceExportColumns,
      fileName: `attendance__${fromDate}__${toDate}`,
      sheetName: "attendance",
      columnWidths: [{ wch: 25 }, { wch: 20 }, { wch: 15 }, { wch: 20 }],
    });
  };
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <div className="text-secondary mb-2 mb-md-0">
          <strong>Attendance Report:</strong>{" "}
          <span>
            {formatDate(fromDate)} – {formatDate(toDate)}
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Form.Label className="mb-0 text-secondary">From</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setfromDate(e.target.value)}
            max={toDate}
            style={{ width: "150px" }}
            required
          />

          <Form.Label className="mb-0 text-secondary">To</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => settoDate(e.target.value)}
            min={fromDate}
            max={formatYYYYMMDD(today)}
            style={{ width: "150px" }}
            required
          />
        </div>
        <Button variant="btn btn-success btn-sm" onClick={handleExport}>
          <i className="las la-file-excel mr-1"></i>
          {t("export") || "Export to Excel"}
        </Button>
      </div>

      <Tab.Container defaultActiveKey="home-tab">
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="home-tab">Attendance Per Employee </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="second-tab">Attendance Per Date</Nav.Link>
          </Nav.Item>
          {/* <Nav.Item>
            <Nav.Link eventKey="contact-tab">Contact</Nav.Link>
          </Nav.Item> */}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="home-tab">
            <BasicTable
              data={
                Array.isArray(employeeAttendance?.summary)
                  ? employeeAttendance.summary
                  : []
              }
              columns={employeeAttendanceColumns}
              title={`attendance_report`}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="second-tab">
            <BasicTable
              data={
                Array.isArray(branchAttendance?.attendance)
                  ? branchAttendance.attendance
                  : []
              }
              columns={attendanceColumns}
              title={`attendance_report`}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="contact-tab">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};
export default AttendanceReport;
